import { z } from "zod"

import {
  branchIdSchema,
  correlationIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
} from "./identifiers.js"

export const fleetMaintenanceDeferralCreateV1Schema = z.object({
  requestVersion: z.literal(1),
  correlationId: correlationIdSchema,
  idempotencyKey: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
  deferralId: entityIdSchema,
  assetId: entityIdSchema,
  scheduleVersionId: entityIdSchema,
  assetRevisionId: entityIdSchema,
  statusEventId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  branchId: branchIdSchema,
  expectedVersion: z.number().int().positive(),
  startsAt: z.iso.datetime({ offset: true }),
  expiresAt: z.iso.datetime({ offset: true }),
  reason: z.string().trim().min(3).max(512),
  impactAcknowledged: z.literal(true),
}).strict().superRefine((value, context) => {
  const startsAt = Date.parse(value.startsAt)
  const expiresAt = Date.parse(value.expiresAt)
  const maximum = 30 * 24 * 60 * 60 * 1_000
  if (expiresAt <= startsAt || expiresAt - startsAt > maximum) {
    context.addIssue({
      code: "custom",
      message: "A maintenance deferral must be positive and no longer than 30 days.",
    })
  }
})

export const fleetMaintenanceDeferralResultV1Schema = z.object({
  entityType: z.literal("fleet_asset"),
  entityId: entityIdSchema,
  state: z.literal("maintenance_deferred"),
  version: z.number().int().positive(),
  deferralId: entityIdSchema,
  scheduleVersionId: entityIdSchema,
  startsAt: z.iso.datetime({ offset: true }),
  expiresAt: z.iso.datetime({ offset: true }),
  maintenanceStatus: z.literal("maintenance_deferred"),
  operatingStatus: z.literal("Maintenance Due"),
  impactWarning: z.literal("maintenance_remains_due_during_deferral"),
}).strict()

export type FleetMaintenanceDeferralCreateV1 =
  z.infer<typeof fleetMaintenanceDeferralCreateV1Schema>
export type FleetMaintenanceDeferralResultV1 =
  z.infer<typeof fleetMaintenanceDeferralResultV1Schema>
